function stripHtmlTags(source) {
  return source.replace(/<[^>]*>/g, "");
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  stripHtmlTags
};
//# sourceMappingURL=stripHtmlTags.js.map
